import { render, staticRenderFns } from "./CreateProxyError.vue?vue&type=template&id=651d46cc&"
import script from "./CreateProxyError.vue?vue&type=script&lang=ts&"
export * from "./CreateProxyError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports